import { createSlice } from '@reduxjs/toolkit';

export const currentPageSlice = createSlice({
  name: 'CurrentPage',
  initialState: {
    CurrentPage: 1,
  },
  reducers: {
    SET_ACTIVECURRENTPAGE_COUNT: (state, action) => {
      state.CurrentPage = action.payload;
    },
  },
});

export const { SET_ACTIVECURRENTPAGE_COUNT } = currentPageSlice.actions;
export default currentPageSlice.reducer;


